import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

import {
  requestViewAllClassifications,
  requestViewAllCategories,
  requestViewAllTypes,
  requestViewAllSpecifications,
} from '../../../api/product/product.actions';

import ProductSpecifications from '../../../components/screens/admin/product-specifications/ProductSpecifications';

const ProductSpecificationsContainer = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { specifications } = useSelector(({ product }) => product);

  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const retrieveClassifications = useCallback(() => {
    dispatch(requestViewAllClassifications());
  }, [dispatch]);

  const retrieveSpecifications = useCallback(
    (filters) => {
      dispatch(
        requestViewAllSpecifications({
          filters,
          onSuccess: (totalSpecifcations) => {
            setTotalPages(Math.ceil(totalSpecifcations / filters.recordsPerPage));
            setCurrentPage(filters.page);
          },
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    const filters = {
      page: 0,
      recordsPerPage: 20,
    };

    retrieveClassifications();
    retrieveSpecifications(filters);
  }, [dispatch, retrieveClassifications, retrieveSpecifications]);

  const retrieveCategories = (classificationExternalReference) => {
    dispatch(requestViewAllCategories({ classificationExternalReference }));
  };

  const retrieveTypes = (categoryExternalReference) => {
    dispatch(requestViewAllTypes({ categoryExternalReference }));
  };

  const navigateToProductSpecifications = () => {
    navigate('/admin/product-specifications');
  };

  const mappedSpecifications = specifications.map((specification) => ({
    productClassification: specification.classification.name,
    productCategory: specification.category.name,
    productType: specification.type.name,
    metrics: specification.metricUnits.join(', '),
    specification,
  }));

  return (
    <ProductSpecifications
      specifications={mappedSpecifications}
      currentPage={currentPage}
      totalPages={totalPages}
      retrieveClassifications={retrieveClassifications}
      retrieveCategories={retrieveCategories}
      retrieveTypes={retrieveTypes}
      retrieveSpecifications={retrieveSpecifications}
      specification={params.specification}
      navigateToProductSpecifications={navigateToProductSpecifications}
    />
  );
};

export default ProductSpecificationsContainer;
